import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InitialValidationSchema } from "src/content/cuModule/DraftNewRfp/Modal/FormModel/ValidationSchema";
import {
  AddFavoritePanel,
  AddReviewDetail,
  AddUserDetails,
  AddUserGroupModel,
  ChangePassword,
  ChartData,
  CloneUploadedFile,
  CorporateProvider,
  EditCorporateModel,
  EditUserModel,
  FileData,
  FileDetails,
  InviteVendorModal,
  LegalServiceProviders,
  LegalServiceReview,
  RFPAbortModel,
  RfpApproval,
  Status,
  UserRole,
} from "src/models/form_post";
import {
  FavouriteListModel,
  preferredPanelFile,
  ProposalStatusDetails,
  RfpListModel,
  RfpParams,
  TemplateListModel,
} from "src/models/rfp";
import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from "src/utils/axios";
import { errorHandler } from "src/utils/errorHandler";
import {
  deleteFilesUrl,
  deleteFileUrl,
  deleteTcsCorpUserGroupMemberUrl,
  deleteTcsCorpUserGroupUrl,
  getBidderListURL,
  analyticsURL,
  getFile,
  getFileUrl,
  getPrefferedList,
  getProposalCVUrl,
  getProposalDetailList,
  getProposalSideScreenUrl,
  getProposalStatusUrl,
  getRfpApproverList,
  getRfpList,
  getRfpRequestorsUrl,
  getRfpListAdmin,
  getTApproverListUrl,
  getAssignableUsersUrl,
  assignRfpUrl,
  rfpCoRequestorsUrl,
  auditLogExportURL,
  auditLogFiltersURL,
  auditLogListURL,
  getCptApproverListUrl,
  rfpAuditLogUrl,
  requestProposalResubmissionUrl,
  getTcsCorporateAddMemberDropUserGroupUrl,
  getTcsCorporatePreferredPanelFileList,
  getTcsCorporateUserGroupUrl,
  getTcsCorpUserGroupDetailUrl,
  getURLForEnum,
  getUserDetailUrl,
  getUserRoleList,
  postCloneFileUploadURL,
  postFileUploadURL,
  postTcsCorporate,
  PostTcsCorpUserUrl,
  postTcsVendor,
  putSelectedBiddersUrl,
  putTcsCorpAddOrRemoveAdminUrl,
  putTcsCorpUserGroupUpdateStatusUrl,
  ConfigURL,
  tcsCorporateCreateUserGroupUrl,
  tcsCorporateUpdateUserGroupUrl,
  templateBankUrl,
  inviteUser,
  serviceReviewURL,
} from "src/utils/pathConst";

export type ErrorInformation = {
  message: string;
  status: number;
};

type CorporateState = {
  loading: boolean;
  error: ErrorInformation;
  corporateData: object;
  corporateStepTwo: object;
  corporateSpecificValue: object;
  corporateRfpData: any;
  user_details: AddUserDetails;
  reviewDetail: AddReviewDetail;
  rfpListModel: RfpListModel;
  rfpListAdmin: RfpListModel;
  tcsRfpUserGroupList: any;
  favoriteListModel: FavouriteListModel;
  getStatus: Status;
  getLegalServiceProviders: LegalServiceProviders;
  getLegalServiceProviderByCorporate: LegalServiceProviders;
  legalServicesProviderReview: LegalServiceReview;
  getCorporateService: CorporateProvider;
  getChartData: ChartData;
  getTeamMemberData: Status;
  getTeamMemberByCorporateData: Status;
  getCorporateDynamicData: Status;
  getLSTeamMemberData: Status;
  getScoreCardData: Status;
  getGlobalScoreCardData: Status;
  getUserValues: Status;
  getFileValue: FileData;
  tcsCorpUserGroupViewDetail: any;
  corporateListStatus: any;
  businessData: any;
  financialYearData: any;
  bidderListData: any;
  approvedVendorData: any;
  rfpLevelData: any;
  rfpworkLocationData: any;
  rfpTowerData: any;
  rfpTimeZoneData: any;
  rfpTypeWorkData: any;
  rfpRateCardData: any;
  rfpTypeServiceData: any;
  tApproverListData: any;
  rfpWinnerAndLoser: any;
  rfpSelection: any;
  editUser: EditUserModel;
  abort: RFPAbortModel;
  changePassword: ChangePassword;
  updateUserProfile: any;
  updatefavoriteBidder: any;
  CorporateScoreData: any;
  SpecificCorporateScoreData: any;
  CorporateScoreDataWithoutKtm: any;
  deleteTemplate: any;
  preliminaryInfoSection: any;
  draftRfpSchema: any;
  sbsBidders: any;
  vendorStatusData: any;
  stage1ServicesReviewData: any;
  stage2ServicesReviewData: any;
};

const initialState: CorporateState = {
  loading: true,
  error: null,
  rfpListModel: null,
  rfpListAdmin: null,
  tcsRfpUserGroupList: null,
  favoriteListModel: null,
  corporateData: {
    role: "cu",
    company_name: "",
    logo: {
      file: [],
    },
    first_name: "",
    surname: "",
    address: "",
    country: "",
    city: "",
    zip: "",
    phone_number: "",
    email: "",
    headquarters_country_id: "",
    headquarters_comments: "",
    file: null,
  },
  corporateStepTwo: {
    industry_id: "",
    industry_comments: "",
    company_size_id: "",
    department_size_id: "",
    spend_id: null,
    comments: "",
    terms_of_services: false,
    how_you_hear_about_navan_legal: {
      value: "",
      comment: "",
    },
    otherValue: "",
    logo: {
      file: [
        {
          actual_name: "",
          type: "",
          internal_name: "",
          status: "",
        },
      ],
    },
  },
  corporateSpecificValue: {
    is_restricted: false,
  },
  corporateRfpData: "",
  user_details: null,
  reviewDetail: null,
  getStatus: null,
  getLegalServiceProviders: null,
  getLegalServiceProviderByCorporate: null,
  legalServicesProviderReview: null,
  getCorporateService: null,
  getChartData: null,
  getTeamMemberData: null,
  getTeamMemberByCorporateData: null,
  getCorporateDynamicData: null,
  getLSTeamMemberData: null,
  getScoreCardData: null,
  getGlobalScoreCardData: null,
  getUserValues: null,
  getFileValue: null,
  tcsCorpUserGroupViewDetail: null,
  corporateListStatus: null,
  rfpWinnerAndLoser: null,
  rfpSelection: null,
  editUser: null,
  abort: null,
  changePassword: null,
  updateUserProfile: null,
  updatefavoriteBidder: null,
  CorporateScoreData: null,
  SpecificCorporateScoreData: null,
  CorporateScoreDataWithoutKtm: null,
  deleteTemplate: null,
  businessData: null,
  financialYearData: null,
  bidderListData: null,
  approvedVendorData: [],
  rfpLevelData: null,
  rfpworkLocationData: null,
  rfpTimeZoneData: null,
  rfpTowerData: null,
  rfpTypeWorkData: null,
  rfpRateCardData: null,
  rfpTypeServiceData: null,
  tApproverListData: null,
  preliminaryInfoSection: {
    project: true,
    deadlines: true,
    ecw: true,
    terms: true,
  },
  // draftRfpSchema: validationSchema,
  draftRfpSchema: InitialValidationSchema,
  sbsBidders: null,
  vendorStatusData: null,
  stage1ServicesReviewData: null,
  stage2ServicesReviewData: null,
};

export const vendorSignUp = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("vendor-signup/invite", async (params, { rejectWithValue }) => {
  try {
    const getResponse = await apiPost(`${inviteUser}/invite`, params);
    return getResponse.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const vendorDraft = createAsyncThunk<
  any,
  { bodyParams: any }, // Add `id` here
  { rejectValue: ErrorInformation }
>("vendor-signup/draft", async ({ bodyParams }, { rejectWithValue }) => {
  try {
    // Use the provided `id` in the API URL
    const getResponse = await apiPost(
      `${inviteUser}/draft/${bodyParams._id}`,
      bodyParams
    );
    return getResponse.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const vendorSubmit = createAsyncThunk<
  any,
  { bodyParams: any },
  { rejectValue: ErrorInformation }
>("vendor-signup/submit", async ({ bodyParams }, { rejectWithValue }) => {
  try {
    // Use the provided `id` in the API URL
    const getResponse = await apiPost(
      `${inviteUser}/submit/${bodyParams._id}`,
      bodyParams
    );
    return getResponse.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const vendorPostEmail = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("vendorPostEmail", async (params, { rejectWithValue }) => {
  try {
    const getResponse = await apiPost(
      `${postTcsVendor}/request_additional_info`,
      params
    );
    return getResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpListview = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RfpListModel", async (params: RfpParams, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(
      `${getRfpList}?limit=${params.limit}&offset=${params.offset}&sortDir=${
        params.sortDir
      }&sortBy=${params.sortBy}&isDashboard=${params.is_dashboard}${
        params.search_string !== ""
          ? "&searchString=" + `${params.search_string}`
          : ""
      }${params.status !== "" ? `&status=${params.status}` : ""}${
        params.requestor ? `&requestor=${params.requestor}` : ""
      }${params.tower ? `&tower=${params.tower}` : ""}`
    );
    return getResponse.data.detail[0];
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpRequestors = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RFPRequestors", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getRfpRequestorsUrl);
    return getResponse.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getVendorList = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getVendorList",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${postTcsVendor}/list?limit=${params.limit}&offset=${
          params.offset
        }&sortDir=${params.sortDir}&sortBy=${params.sortBy}${
          params.search_string !== ""
            ? "&searchString=" + `${params.search_string}`
            : ""
        }${params.status !== "" ? `&status=${params.status}` : ""}`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const postInviteVendor = createAsyncThunk<
  InviteVendorModal,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/postInviteVendor",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${postTcsVendor}/invite`, bodyParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getVendorDetail = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getVendorDetail", async (params: any, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(
      `${postTcsVendor}/get_detail/${params?._id}`
    );
    return getResponse.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const vendorApproveOrDecline = createAsyncThunk<
  RfpApproval,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/vendorApproveOrDecline",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const url1 = `${postTcsVendor}/${bodyParams.vendor_id}/${bodyParams.status_id}`;
      const response = await apiPatch(
        url1,
        bodyParams.comment && { comment: bodyParams.comment }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const updateVendorCategory = createAsyncThunk<
  any,
  { bodyParams: { vendor_id: string; category: string[] } },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/updateVendorCategory",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const url = `${postTcsVendor}/category/${bodyParams.vendor_id}`;
      const response = await apiPut(url, { category: bodyParams.category });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

/* The categories in use across the panel, for the suggestion list in the invite and edit pickers.
   There is no master list of categories - the vocabulary is whatever has been typed so far - so
   this is derived from the vendors themselves. */
export const getVendorCategories = createAsyncThunk<
  string[],
  void,
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getVendorCategories", async (_params, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(`${postTcsVendor}/categories`);
    return getResponse.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpBiddersList = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/RfpBiddersList",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      /* sortBy is left off entirely when the caller has not picked a column, so the API keeps its
         default of favourites first then name - passing an empty sortBy would drop that. */
      const getResponse = await apiGet(
        `${getBidderListURL}?offset=${params.offset}&limit=${params.limit}&${
          params.search_string !== ""
            ? "&searchString=" + `${params.search_string}`
            : ""
        }${
          params.sortBy
            ? `&sortBy=${params.sortBy}&sortDir=${params.sortDir || "asc"}`
            : ""
        }`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// Fetch all bidder data

export const getApprovedVendorList = createAsyncThunk<
  {},
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getApprovedVendorList", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(`${postTcsVendor}/list?all=true`);
    return getResponse.data?.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getApprovedServicedVendorList = createAsyncThunk<
  {},
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getApprovedServicedVendorList",
  async ({}, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${serviceReviewURL}/list_vendors_by_fy`
      );
      return getResponse.data?.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const fetchScoreCardByVendorId = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/fetchScoreCardByVendorId",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${analyticsURL}/score_card/${params?.vendor_id}`
      );
      return getResponse.data?.details;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const fetchInvitationOutComes = createAsyncThunk<
  {},
  any,
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/fetchInvitationOutComes", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(`${analyticsURL}/invitation_outcomes`);
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const fetchFilteredInvitationOutcomes = createAsyncThunk<
  {},
  any,
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/fetchFilteredInvitationOutcomes",
  async (params: any, { rejectWithValue }) => {
    const urlParams = new URLSearchParams();
    if (params?.vendor_ids && Array.isArray(params.vendor_ids))
      params.vendor_ids.forEach((vendor_id) =>
        urlParams.append("vendor_ids[]", vendor_id)
      );
    if (params?.from_date) urlParams.append("from_date", params.from_date);
    if (params?.to_date) urlParams.append("to_date", params.to_date);
    try {
      const getResponse = await apiGet(
        `${analyticsURL}/invitation_outcomes?${urlParams.toString()}`
      );
      return getResponse.data.details;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);
export const getSingaporeTime = createAsyncThunk<
  {},
  any,
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RfpBiddersList", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(`${ConfigURL}/TIMEZONE_CONFIG`);
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpLevelData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RfpLevel", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "RFPLevel");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpWorkLocationData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RfpWorkLocation", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "WorkLocation");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getFinancialList = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getFinancialList", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "FinancialYears");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});


export const getServiceReviewStatus = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getServiceReviewStatus", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "ServiceReviewStatus");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpBusinessData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RFPBusinessUnit", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "BusinessUnits");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpTowerData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RFPTower", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "Tower");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpTypeOfWorkData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RFPTypeOfWork", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "TypeOfWork");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

// For Draft RFP
export const getDraftRfpTowerData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getDraftRfpTowerData",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getURLForEnum}Tower?dependant_id=${params?.dependent_id}`
      );
      return getResponse.data.details;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getRfpTimeZonesData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RFPTimeZones", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "TimeZones");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpTypeOfServicesData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RFPTypeOfServices", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "TypeOfServices");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

// For Draft RFP
export const getDraftRfpTypeOfServicesData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getDraftRfpTypeOfServicesData",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getURLForEnum}TypeOfServices?dependant_id=${params?.dependent_id}`
      );
      return getResponse.data.details;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getRfpTypeOfRateCardData = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RFPTTypeOfRateCard", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "TypeOfRateCard");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});
export const getRfpStatus = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/RfpStatus", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "RFPStatus");
    return getResponse.data?.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getVendorStatus = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getVendorStatus", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(`${getURLForEnum}/VendorStatus`);
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});
//TODO: Admin RFP
export const getRfpAdminList = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getRfpAdminList",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getRfpListAdmin}?search_string=${params?.search_string}&sortBy=${params?.sortBy}&sortDir=${params?.sortDir}&limit=${params?.limit}&offset=${params?.offset}&status=${params?.status}`
      );
      return getResponse?.data?.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getFileDetails = createAsyncThunk<
  FileData,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/getFile", async (params: FileDetails, { rejectWithValue }) => {
  try {
    const getFileResponse = await apiGet(
      `${getFile}?key=${params.key}&actual_name=${params.actual_name}`
    );

    return getFileResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getProposalStatus = createAsyncThunk<
  ProposalStatusDetails,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getProposalStatusDetails",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getProposalStatusUrl}/${params.corporate_id}/${params.rfp_id}/proposal-status`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);
//Post Tcs UserGroup data
export const postTcsCorporateUserGroup = createAsyncThunk<
  AddUserGroupModel,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/postTcsCorporateUserGroup",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiPost(
        `${tcsCorporateCreateUserGroupUrl}`,
        bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//Update Tcs UserGroup Data
export const putTcsCorporateUserGroup = createAsyncThunk<
  AddUserGroupModel,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/putTcsCorporateUserGroup",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const userGroupId = bodyParams.userGroupId;
      delete bodyParams.userGroupId;
      const response = await apiPut(
        `${tcsCorporateUpdateUserGroupUrl}/${userGroupId}`,
        bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//UserGroup List API
export const getTcsCorporateUserGroup = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getTcsCorporateUserGroup",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getTcsCorporateUserGroupUrl}?sortBy=${params.sortBy}&sortDir=${params.sortDir}&limit=${params.limit}&offset=${params.offset}&status=${params.status}&searchString=${params.search_string}`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// Evaluator Fetch MEthod
export const fetchEvaluatorList = createAsyncThunk<
  FavouriteListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/fetchEvaluatorList", async (params: any, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(
      `${getTcsCorporateAddMemberDropUserGroupUrl}?all=true`
    );
    return getResponse.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

//UserGroup AddMember Dropdown Api
export const getTcsCorporateAddMemberDropUserGroup = createAsyncThunk<
  FavouriteListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getTcsCorporateAddMemberDropUserGroup",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getTcsCorporateAddMemberDropUserGroupUrl}?sortBy=${params.sortBy}&sortDir=${params.sortDir}&limit=${params.limit}&offset=${params.offset}&status=${params.status}&searchString=${params.search_string}&corporateId=${params.corporateId}`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// UserGroup Change Status API
export const putTcsCorpUserGroupUpdateStatus = createAsyncThunk<
  AddUserDetails,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/putTcsCorpUserGroupUpdateStatus",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiPut(
        `${putTcsCorpUserGroupUpdateStatusUrl}/${bodyParams.userGroupId}`,
        bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// UserGroup Delete API
export const deleteTcsCorpUserGroup = createAsyncThunk<
  AddUserDetails,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/deleteTcsCorpUserGroup",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiDelete(
        `${deleteTcsCorpUserGroupUrl}/${bodyParams.userGroupId}`,
        bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//View UserGroup API
export const getTcsCorpUserGroupDetail = createAsyncThunk<
  FavouriteListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getTcsCorpUserGroupDetail",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getTcsCorpUserGroupDetailUrl}/${params.userGroupId}`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//Service List
export const getServiceReviewList = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getServiceReviewList",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${serviceReviewURL}/list?sortBy=${params.sortBy}&sortDir=${params.sortDir}&limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}&status=${params.status}`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// getService ReviewBy Id
export const getServiceReviewById = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getServiceReviewById",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${serviceReviewURL}/get_detail/${params.vendor_id}`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getServiceReviewExportData = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getServiceReviewById",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiPost(
        `${analyticsURL}/export_service_review`,
        params
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//financial based on vendor id

export const getFinancialBasedOnVendorId = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getFinancialBasedOnVendorId",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${serviceReviewURL}/get_fy_by_vendor/${params.vendor_id}`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//Post Service Review
export const postServiceReview = createAsyncThunk<
  {},
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/postServiceReview", async (bodyParams, { rejectWithValue }) => {
  try {
    const response = await apiPost(`${serviceReviewURL}`, bodyParams);
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

//Put Service Review
export const putServiceReview = createAsyncThunk<
  any,
  any,
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/postServiceReview", async (bodyParams, { rejectWithValue }) => {
  try {
    const { reviewId, ...updatedBodyParams } = bodyParams;
    const response = await apiPut(`${serviceReviewURL}/${bodyParams?.reviewId}`, updatedBodyParams);
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});
//Tcs Corporate Users List
export const getTcsCorpUserList = createAsyncThunk<
  Status,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/getTcsCorpUserList", async (params: any, { rejectWithValue }) => {
  const url = `${getUserDetailUrl}/by-corporate-id/${params.corporate_id}?limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}&sortDir=${params.sortDir}&sortBy=${params.sortBy}&role=${params.role}`
  try {
    const getTeamResponse = await apiGet(url);
    return getTeamResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getCorporateUserList = createAsyncThunk<
  Status,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/getCorporateUserList", async (params: any, { rejectWithValue }) => {
  try {
    const getTeamResponse = await apiGet(
      `${getUserDetailUrl}/by-vendor-id/${params.vendor_id}?limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}&sortDir=${params.sortDir}&sortBy=${params.sortBy}`
    );
    return getTeamResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const fetchUpdatedUserList = createAsyncThunk<
  Status,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/fetchUpdatedUserList", async (params: any, { rejectWithValue }) => {
  try {
    const urlParams = new URLSearchParams();
    if (params && Array.isArray(params)){
      params.forEach((vendor, index) => {
        Object.entries(vendor).forEach(([key, value]) => {
          urlParams.append(`vendors[${index}][${key}]`, String(value));
        });
      });
    }
    const getTeamResponse = await apiGet(
      `${getProposalDetailList}/get_inviting_bidder?${urlParams.toString()}`
    );
    return getTeamResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const checkNonAccreditedVendor = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/checkNonAccreditedVendor", async (params: any, { rejectWithValue }) => {
  try {
    const getTeamResponse = await apiPost(
      `${getProposalDetailList}/check_non_acc_vendor`, params
    );
    return getTeamResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getTApproverList = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getTApproverList", async (params: any, { rejectWithValue }) => {
  try {
    const getTeamResponse = await apiGet(
      `${getTApproverListUrl}?limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}`
    );
    return getTeamResponse.data.detail[0];
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});
/*
 * Corporate users the current requester can hand a Capacity Request to, for the Assign modal.
 * Same shape as getTApproverList, but not filtered by role.
 */
export const getAssignableUsers = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getAssignableUsers", async (params: any, { rejectWithValue }) => {
  try {
    const response = await apiGet(
      `${getAssignableUsersUrl}?limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}`
    );
    return response.data.detail[0];
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

/*
 * Replace the co-requestor list on a Capacity Request.
 *
 * Full-replacement semantics: whatever is sent becomes the new active list, and anyone dropped is
 * revoked server-side. Deliberately NOT part of the Capacity Request save - the collaborator list
 * is its own resource, so the wizard's payload builders cannot clobber it and the dialog does not
 * have to rebuild the whole form to add one person.
 */
export const updateRfpCoRequestors = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/updateRfpCoRequestors",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await apiPut(
        rfpCoRequestorsUrl(params.rfp_id),
        params.bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

/*
 * Assign a Capacity Request to another requester after declaring a conflict of interest.
 * The in-progress form travels with the call and is saved as a draft, so only draft-level
 * validation applies here - the full submission checks run when the assignee submits it.
 */
export const assignRfpToRequester = createAsyncThunk<
  any,
  any,
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/assignRfpToRequester", async (bodyParams: any, { rejectWithValue }) => {
  try {
    const response = await apiPost(assignRfpUrl, bodyParams);
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

/*
 * One Capacity Request's own audit trail, a page at a time, newest first.
 *
 * Separate from getAuditLogList, which reads the tenant-wide auditLogs collection for the
 * system-admin page. This one reads rfpRevisions, so its rows carry the per-field previous and
 * new values that collection was never able to reconstruct.
 */
export const getRfpAuditLog = createAsyncThunk<
  any,
  any,
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getRfpAuditLog",
  async (
    params: { rfpId: string; limit?: number; offset?: number },
    { rejectWithValue }
  ) => {
    try {
      const query = new URLSearchParams();
      query.set("limit", String(params.limit ?? 25));
      query.set("offset", String(params.offset ?? 0));
      const response = await apiGet(
        `${rfpAuditLogUrl}/${params.rfpId}/audit-log?${query.toString()}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

/*
 * The whole trail for one request, for the spreadsheet export.
 *
 * POST with no body on purpose - it mirrors the tenant-wide export, where the verb is what makes
 * the request reach the audit middleware. Exporting an audit trail is itself worth recording.
 */
export const exportRfpAuditLog = createAsyncThunk<
  any,
  any,
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/exportRfpAuditLog", async (rfpId: string, { rejectWithValue }) => {
  try {
    const response = await apiPost(
      `${rfpAuditLogUrl}/${rfpId}/audit-log/export`,
      {}
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

/*
 * Ask a bidder to revise and resubmit their fee proposal.
 *
 * Does not change the proposal status - editing an already-submitted proposal is supported, so
 * this is purely the request, plus the window the bidder is given to act on it: `new_deadline`
 * moves the Capacity Request's submission deadline, without which a bidder asked to revise after
 * the deadline has closed has no form left to submit against.
 *
 * The API rejects it unless the proposal is Submitted and the caller owns or approves the
 * Capacity Request.
 */
export const requestProposalResubmission = createAsyncThunk<
  any,
  { proposal_id: string; comment: string; new_deadline: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/requestProposalResubmission",
  async ({ proposal_id, comment, new_deadline }, { rejectWithValue }) => {
    try {
      const response = await apiPost(
        `${requestProposalResubmissionUrl}/${proposal_id}/request-resubmission`,
        { comment, new_deadline }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

/*
 * Ask EVERY invited vendor on a Capacity Request to revise and resubmit, against a new deadline.
 *
 * Request-level rather than per-proposal because the deadline is request-level: one date, one
 * reason, one call. The vendors are emailed the resubmission request rather than the
 * deadline-change notice - what they are being asked for is a revised proposal, not just a new
 * date. The API rejects it unless the caller owns or approves the Capacity Request.
 */
export const requestRfpResubmission = createAsyncThunk<
  any,
  { rfp_id: string; comment: string; new_deadline: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/requestRfpResubmission",
  async ({ rfp_id, comment, new_deadline }, { rejectWithValue }) => {
    try {
      const response = await apiPost(
        `${requestProposalResubmissionUrl}/rfp/${rfp_id}/request-resubmission`,
        { comment, new_deadline }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

/* Capacity Requests waiting on the CPT approval gate. */
export const getCptApproverList = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getCptApproverList", async (params: any, { rejectWithValue }) => {
  try {
    const response = await apiGet(
      `${getCptApproverListUrl}?limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}&sortDir=${params.sortDir}&sortBy=${params.sortBy}`
    );
    return response.data.detail[0];
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

/* ---------------------------------------------------------------------------------------
 * Audit Logs
 *
 * The list endpoint takes every filter as a query param and celebrate rejects unknown keys
 * (schema.options is undefined across this codebase), so only params with a value are appended
 * - sending `activity=` for "All" would be a 400.
 * ------------------------------------------------------------------------------------- */
const auditQueryString = (params: any) => {
  const query = new URLSearchParams();
  query.set("limit", String(params.limit));
  query.set("offset", String(params.offset));
  if (params.searchString) query.set("searchString", params.searchString);
  if (params.activity && params.activity !== "All")
    query.set("activity", params.activity);
  if (params.userId && params.userId !== "All") query.set("userId", params.userId);
  if (params.fromDate) query.set("fromDate", params.fromDate);
  if (params.toDate) query.set("toDate", params.toDate);
  return query.toString();
};

export const getAuditLogList = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getAuditLogList", async (params: any, { rejectWithValue }) => {
  try {
    const response = await apiGet(`${auditLogListURL}?${auditQueryString(params)}`);
    return response.data.detail[0];
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getAuditLogFilters = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getAuditLogFilters", async (_params: any, { rejectWithValue }) => {
  try {
    const response = await apiGet(auditLogFiltersURL);
    return response.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

/* Export is a POST so the export itself lands in the audit trail. */
export const exportAuditLogs = createAsyncThunk<
  any,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/exportAuditLogs", async ({ bodyParams }, { rejectWithValue }) => {
  try {
    const response = await apiPost(auditLogExportURL, bodyParams);
    return response.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

//Tcs UserGroup AddOrRemoveAdmin API
export const putTcsCorpAddOrRemoveAdmin = createAsyncThunk<
  AddUserDetails,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/putTcsCorpAddOrRemoveAdmin",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiPut(
        `${putTcsCorpAddOrRemoveAdminUrl}/${bodyParams.user_group_id}/${bodyParams.member_id}`,
        bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//AddNewUser in Users API
export const PostTcsCorpUser = createAsyncThunk<
  AddUserDetails,
  { user_details: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/PostTcsCorpUser",
  async ({ user_details }, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${PostTcsCorpUserUrl}`, user_details);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const UpdateTcsCorpUser = createAsyncThunk<
  EditUserModel,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/UpdateTcsCorpUser",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const url1 = `${PostTcsCorpUserUrl}/profile`;
      const url2 = `${PostTcsCorpUserUrl}/${bodyParams.user_id}`;
      const response = await apiPatch(
        bodyParams?.isProfile ? url1 : url2,
        bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const DeleteTcsCorpUser = createAsyncThunk<
  AddUserDetails,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/deleteTcsCorpUserGroup",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiDelete(
        `${PostTcsCorpUserUrl}/${bodyParams.user_id}`,
        bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);
// Get UserRole
export const GetUserRoleData = createAsyncThunk<
  UserRole,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/GetUserRoleData", async (params: any, { rejectWithValue }) => {
  try {
    const fetchUserRole = await apiGet(
      `${getUserRoleList}/${params.userTypeId}`
    );
    return fetchUserRole.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

//Delete UserGroup Member API
export const deleteTcsCorpUserGroupMember = createAsyncThunk<
  AddUserDetails,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/deleteTcsCorpUserGroupMember",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiDelete(
        `${deleteTcsCorpUserGroupMemberUrl}/${bodyParams.user_group_id}/${bodyParams.member_id}`,
        bodyParams
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//GET TEMPLATE BANK API
export const getTemplateBankList = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getTemplateBankList",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${templateBankUrl}/list?limit=${params.limit}&offset=${
          params.offset
        }&sortDir=${params.sortDir}&sortBy=${params.sortBy}${
          params.search_string !== ""
            ? "&searchString=" + params.search_string
            : ""
        }`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const previewRFPApproval = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/previewRFPApproval",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getProposalDetailList}/get_detail/${params.id}`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// GET TEmplate Bank Preview
export const previewTemplateBank = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/previewTemplateBank",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${templateBankUrl}/get_detail/${params.id}`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// get template preview Data
export const getTemplateBankPreviewData = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/previewTemplateBank",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${templateBankUrl}/preview_detail/${params.id}`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

//Delete Template Bank

export const deleteTemplateBank = createAsyncThunk<
  any,
  { params: any },
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/DeleteTemplateBank", async ({ params }, { rejectWithValue }) => {
  try {
    const response = await apiDelete(`${templateBankUrl}/${params}`, params);
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

// GET PREFFERED PANEL API
export const getPreferedPanelList = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getPreferedPanelList",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getPrefferedList}/list?limit=${params.limit}&offset=${
          params.offset
        }&sortDir=${params.sortDir}&sortBy=${params.sortBy}${
          params.search_string !== ""
            ? "&searchString=" + params.search_string
            : ""
        }`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// PREFERRED PANEL POST API
export const addPreferredFavorite = createAsyncThunk<
  AddFavoritePanel,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/PostFavoritePanel",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${getPrefferedList}`, bodyParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// REMOVE PANEL DELETE API
export const deletePreferredFavorite = createAsyncThunk<
  any,
  { params: any },
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/PostFavoritePanel", async ({ params }, { rejectWithValue }) => {
  try {
    const response = await apiDelete(
      `${getPrefferedList}/remove/${params.favoriteId}`,
      params
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getRfpApproverListView = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getRfpApproverList",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getRfpApproverList}?offset=${params.offset}&limit=${params.limit}&searchString=${params.search_string}&sortDir=${params.sortDir}&sortBy=${params.sortBy}&status=${params.status}`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const postPreferredPanelFile = createAsyncThunk<
  any,
  FormData,
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/postPreferredPanelFile",
  async (bodyParams, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${postFileUploadURL}`, bodyParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getPreferredPanelFileList = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getPreferredPanelFileList", async (_, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(
      `${getTcsCorporatePreferredPanelFileList}/list`
    );
    return getResponse.data.detail[0];
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

//For File Download
export const getPreferredPanelFile = createAsyncThunk<
  any,
  preferredPanelFile,
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getPreferredPanelFile", async (params, { rejectWithValue }) => {
  try {
    const getResponse = await apiPost(`${getFileUrl}`, params);
    return getResponse.data.detail;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const deletePreferredPanelFile = createAsyncThunk<
  any,
  preferredPanelFile,
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/deletePreferredPanelFile",
  async (params, { rejectWithValue }) => {
    try {
      const getResponse = await apiDelete(`${deleteFileUrl}`, params);
      return getResponse.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const deleteMultipleFiles = createAsyncThunk<
  any,
  [preferredPanelFile],
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/deletePreferredPanelFile",
  async (params, { rejectWithValue }) => {
    try {
      const getResponse = await apiDelete(`${deleteFilesUrl}`, params);
      return getResponse.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const UpdateTcsCorporate = createAsyncThunk<
  EditCorporateModel,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/PostTcsCorpUser", async ({ bodyParams }, { rejectWithValue }) => {
  try {
    const response = await apiPut(`${postTcsCorporate}/`, bodyParams);
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const RfpApproveOrDecline = createAsyncThunk<
  RfpApproval,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/RfpApproveOrDecline",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const url1 = `${getProposalDetailList}/${bodyParams.rfp_id}/${bodyParams.status_id}`;
      /* no_conflict carries the approver's conflict-of-interest declaration alongside the
         approve/decline action. Only sent when the Capacity Request is on the two-stage flow -
         omitted entirely otherwise, so requests on the original flow send the body they
         always have. */
      const patchBody: any = {};
      if (bodyParams.comment) patchBody.comment = bodyParams.comment;
      if (typeof bodyParams.no_conflict === "boolean") {
        patchBody.no_conflict = bodyParams.no_conflict;
      }
      // Only present when the approver explicitly declined due to a conflict of interest.
      if (bodyParams.conflict_declared === true) {
        patchBody.conflict_declared = true;
      }
      const response = await apiPatch(
        url1,
        Object.keys(patchBody).length > 0 ? patchBody : undefined
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const UpdateRFPAbort = createAsyncThunk<
  RfpApproval,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/UpdateRFPAbort", async ({ bodyParams }, { rejectWithValue }) => {
  try {
    const url1 = `${getProposalDetailList}/${bodyParams.rfp_id}/${bodyParams.status_id}`;
    const response = await apiPatch(
      url1,
      bodyParams.comment && { comment: bodyParams.comment }
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const UpdateRFPDeadline = createAsyncThunk<
  RfpApproval,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/UpdateRFPDeadline",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const url1 = `${getProposalDetailList}/${bodyParams.rfp_id}/extend-deadline`;
      const response = await apiPatch(url1, {
        proposal_submission_deadline: bodyParams.proposal_submission_deadline,
        extend_deadline_reason: bodyParams.extend_deadline_reason || undefined
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const postRfpFileClone = createAsyncThunk<
  CloneUploadedFile,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/postRfpFileClone",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${postCloneFileUploadURL}`, bodyParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getRfpSideBySideById = createAsyncThunk<
  any,
  { rfp_id: String },
  { rejectValue: ErrorInformation }
>("TcsConnect/getRfpSideBySideById", async (params, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(
      `${getProposalSideScreenUrl}/${params.rfp_id}`
    );

    const allBidders = `[${
      getResponse.data?.detail.length
    }] ${getResponse.data?.detail.map((item) => item?.vendor_name).join(", ")}`;
    const submittedBiddersList = getResponse.data?.detail.filter(
      (item) => item?.proposal_status !== "DidNotBid" && item?.proposal_status !== "AwaitingResponse" && item?.proposal_status !== "Drafting"
    );
    const submittedBidders = `[${
      submittedBiddersList.length
    }] ${submittedBiddersList.map((item) => item?.vendor_name).join(", ")}`;
    const didNotBidderList = getResponse.data?.detail.filter(
      (item) => item?.proposal_status === "DidNotBid"
    );
    const didNotBidders = `[${didNotBidderList.length}] ${didNotBidderList
      .map((item) => item?.vendor_name)
      .join(", ")}`;

    const sbsBidders = {
      all: allBidders,
      submitted: submittedBidders,
      didNotBid: didNotBidders,
    };
    return {
      data: getResponse.data?.detail,
      sbsBidders,
    };
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getProposalCVById = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getProposalCVById", async (params: any, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(
      `${getProposalCVUrl}/${params?.proposal_id}`
    );
    return getResponse.data.detail[0];
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const UpdateSelectedBidders = createAsyncThunk<
  EditCorporateModel,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/UpdateSelectedBidders",
  async ({ bodyParams }, { rejectWithValue }) => {
    try {
      const response = await apiPut(
        `${putSelectedBiddersUrl}/${bodyParams?.id}`,
        bodyParams?.postData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getRFPAccessRuleStatus = createAsyncThunk<
  RfpListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getRFPAccessRuleStatus", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "RfpRestrictedStatus");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const getServiceReviewAnalyticsData = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getRFPAccessRuleStatus", async (params: any, { rejectWithValue }) => {
  try {
    const url = params.financialYear 
      ? `${analyticsURL}/service_review?financial_year_id=${params.financialYear}` 
      : `${analyticsURL}/service_review`;
    const getResponse = await apiGet(url);
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const CorporateSlice = createSlice({
  name: "TcsConnect",
  initialState,
  reducers: {
    updateCorporateFormStepOne: (state, action: PayloadAction<any>) => {
      state.corporateData = action.payload;
    },
    updateCorporateFormStepTwo: (state, action: PayloadAction<any>) => {
      state.corporateStepTwo = action.payload;
    },
    updateCorporateSpecificValue: (state, action: PayloadAction<any>) => {
      state.corporateSpecificValue = action.payload;
    },
    updatePreliminarySection: (state, action: PayloadAction<any>) => {
      state.preliminaryInfoSection = action.payload;
    },
    updateDraftRfpSchema: (state, action: PayloadAction<any>) => {
      state.draftRfpSchema = action.payload;
    },
    updateStage1ServicesReview: (state, action: PayloadAction<any>) => {
      state.stage1ServicesReviewData = action.payload;
    },
    updateStage2ServicesReview: (state, action: PayloadAction<any>) => {
      state.stage2ServicesReviewData = action.payload;
    },
    resetValue: (state) => {
      state.corporateData = {
        role: "cu",
        company_name: "",
        logo: {
          file: [],
        },
        first_name: "",
        surname: "",
        address: "",
        country: "",
        city: "",
        zip: "",
        phone_number: "",
        email: "",
        headquarters_country_id: "",
        headquarters_comments: "",
        how_you_hear_about_navan_legal: {
          value: "",
          comment: "",
        },
        industry_id: "",
        industry_comments: "",
        company_size_id: "",
        department_size_id: "",
        spend_id: "",
        comments: "",
        terms_of_services: false,
      };
      state.corporateSpecificValue = {
        is_restricted: false,
      };
      state.preliminaryInfoSection = {
        project: true,
        deadlines: true,
        ecw: true,
        terms: true,
      };
    },
  },
  extraReducers: {
    //PostAdmin invite slice
    [getRfpListview.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpListview.fulfilled.type]: (
      state,
      action: PayloadAction<RfpListModel | null>
    ) => {
      state.rfpListModel = action.payload;
      state.loading = false;
    },
    [getRfpListview.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getRfpAdminList.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpAdminList.fulfilled.type]: (
      state,
      action: PayloadAction<RfpListModel | null>
    ) => {
      state.rfpListAdmin = action.payload;
      state.loading = false;
    },
    [getRfpAdminList.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getTcsCorporateUserGroup.pending.type]: (state) => {
      state.loading = true;
    },
    [getTcsCorporateUserGroup.fulfilled.type]: (
      state,
      action: PayloadAction<RfpListModel | null>
    ) => {
      state.tcsRfpUserGroupList = action.payload;
      state.loading = false;
    },
    [getTcsCorporateUserGroup.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getFileDetails.pending.type]: (state) => {
      state.loading = true;
    },
    [getFileDetails.fulfilled.type]: (
      state,
      action: PayloadAction<FileData | null>
    ) => {
      state.getFileValue = action.payload;
      state.loading = false;
    },
    [getFileDetails.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getTcsCorpUserGroupDetail.pending.type]: (state) => {
      state.loading = true;
    },
    [getTcsCorpUserGroupDetail.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.tcsCorpUserGroupViewDetail = action.payload;
      state.loading = false;
    },
    [getTcsCorpUserGroupDetail.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getRfpStatus.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpStatus.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.corporateListStatus = action.payload;
      state.loading = false;
    },
    [getRfpStatus.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpLevelData.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpLevelData.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.rfpLevelData = action.payload;
      state.loading = false;
    },
    [getRfpLevelData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpWorkLocationData.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpWorkLocationData.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.rfpworkLocationData = action.payload;
      state.loading = false;
    },
    [getRfpWorkLocationData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpSideBySideById.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpSideBySideById.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.sbsBidders = action.payload.sbsBidders;
      state.loading = false;
    },
    [getRfpSideBySideById.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getFinancialList.pending.type]: (state) => {
      state.loading = true;
    },
    [getFinancialList.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.financialYearData = action.payload;
      state.loading = false;
    },
    [getFinancialList.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpBusinessData.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpBusinessData.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.businessData = action.payload;
      state.loading = false;
    },
    [getRfpBusinessData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpBiddersList.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpBiddersList.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.bidderListData = action.payload;
      state.loading = false;
    },
    [getRfpBiddersList.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getApprovedVendorList.pending.type]: (state) => {
      state.loading = true;
    },
    [getApprovedVendorList.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.approvedVendorData = action.payload;
      state.loading = false;
    },
    [getApprovedVendorList.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpTowerData.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpTowerData.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.rfpTowerData = action.payload;
      state.loading = false;
    },
    [getRfpTowerData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpTypeOfWorkData.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpTypeOfWorkData.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.rfpTypeWorkData = action.payload;
      state.loading = false;
    },
    [getRfpTypeOfWorkData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpTimeZonesData.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpTimeZonesData.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.rfpTimeZoneData = action.payload;
      state.loading = false;
    },
    [getRfpTimeZonesData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getRfpTypeOfRateCardData.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpTypeOfRateCardData.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.rfpRateCardData = action.payload;
      state.loading = false;
    },
    [getRfpTypeOfRateCardData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getRfpTypeOfServicesData.pending.type]: (state) => {
      state.loading = true;
    },
    [getRfpTypeOfServicesData.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.rfpTypeServiceData = action.payload;
      state.loading = false;
    },
    [getRfpTypeOfServicesData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getTApproverList.pending.type]: (state) => {
      state.loading = true;
    },
    [getTApproverList.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.tApproverListData = action.payload;
      state.loading = false;
    },
    [getTApproverList.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getVendorStatus.pending.type]: (state) => {
      state.loading = true;
    },
    [getVendorStatus.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.vendorStatusData = action.payload;
      state.loading = false;
    },
    [getVendorStatus.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { updateCorporateFormStepOne } = CorporateSlice.actions;
export const { updateCorporateFormStepTwo } = CorporateSlice.actions;
export const { updateCorporateSpecificValue } = CorporateSlice.actions;
export const {
  updatePreliminarySection,
  updateDraftRfpSchema,
  updateStage1ServicesReview,
  updateStage2ServicesReview,
} = CorporateSlice.actions;
export const { resetValue } = CorporateSlice.actions;

export default CorporateSlice;
